import React from 'react';
import cn from 'classnames';
import './style.scss';

export enum Color {
  Gray,
  Blue,
  White,
}
interface ContentProps {
  children: React.ReactNode | React.ReactNodeArray;
  color?: Color;
  center?: boolean;
}
const Content: React.FC<ContentProps> = ({ children, color, center }) => {
  return (
    <div
      styleName={cn('content', {
        blue: color === Color.Blue,
        center,
      })}
    >
      <div styleName="content__main">{children}</div>
    </div>
  );
};
export default Content;
